import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const IndexPage = React.lazy(() => import('modules/engagement_insights/pages/IndexPage'))
const LaunchSurveysModalPage = React.lazy(
  () => import('modules/engagement_insights/pages/LaunchSurveysModalPage')
)
const RootPage = React.lazy(() => import('modules/engagement_insights/pages/RootPage'))

export const engagementInsightsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.engagement.insights.path,
      element: <RootPage />,
      children: [
        {
          path: '',
          element: <IndexPage />,
          handle: {
            meta: () => {
              return {
                title: i18n.t('surveys.insights'),
              }
            },
          },
          children: [
            {
              index: true,
              path: navigation.engagement.insights.launch.path,
              element: <LaunchSurveysModalPage />,
            },
          ],
        },
      ],
    },
  ]
}
